"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/legacy_portal_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalEventGoods = exports.LegacyPortalEventGoodsInventoryStatus = exports.LegacyPortalEventGoodsSalesStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * イベントグッズの販売ステータス
 *
 * @generated from enum spwn.event.v1.LegacyPortalEventGoodsSalesStatus
 */
var LegacyPortalEventGoodsSalesStatus;
(function (LegacyPortalEventGoodsSalesStatus) {
    /**
     * 未指定
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalEventGoodsSalesStatus[LegacyPortalEventGoodsSalesStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 販売開始前
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_BEFORE_SALE = 1;
     */
    LegacyPortalEventGoodsSalesStatus[LegacyPortalEventGoodsSalesStatus["BEFORE_SALE"] = 1] = "BEFORE_SALE";
    /**
     * 販売中
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_ON_SALE = 2;
     */
    LegacyPortalEventGoodsSalesStatus[LegacyPortalEventGoodsSalesStatus["ON_SALE"] = 2] = "ON_SALE";
    /**
     * 販売期間終了
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_AFTER_SALE = 3;
     */
    LegacyPortalEventGoodsSalesStatus[LegacyPortalEventGoodsSalesStatus["AFTER_SALE"] = 3] = "AFTER_SALE";
})(LegacyPortalEventGoodsSalesStatus = exports.LegacyPortalEventGoodsSalesStatus || (exports.LegacyPortalEventGoodsSalesStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalEventGoodsSalesStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalEventGoodsSalesStatus, "spwn.event.v1.LegacyPortalEventGoodsSalesStatus", [
    { no: 0, name: "LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_BEFORE_SALE" },
    { no: 2, name: "LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_ON_SALE" },
    { no: 3, name: "LEGACY_PORTAL_EVENT_GOODS_SALES_STATUS_AFTER_SALE" },
]);
/**
 * イベントグッズの在庫ステータス
 *
 * @generated from enum spwn.event.v1.LegacyPortalEventGoodsInventoryStatus
 */
var LegacyPortalEventGoodsInventoryStatus;
(function (LegacyPortalEventGoodsInventoryStatus) {
    /**
     * 未指定
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalEventGoodsInventoryStatus[LegacyPortalEventGoodsInventoryStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 在庫あり
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_IN_STOCK = 1;
     */
    LegacyPortalEventGoodsInventoryStatus[LegacyPortalEventGoodsInventoryStatus["IN_STOCK"] = 1] = "IN_STOCK";
    /**
     * 在庫なし
     *
     * @generated from enum value: LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_OUT_OF_STOCK = 2;
     */
    LegacyPortalEventGoodsInventoryStatus[LegacyPortalEventGoodsInventoryStatus["OUT_OF_STOCK"] = 2] = "OUT_OF_STOCK";
})(LegacyPortalEventGoodsInventoryStatus = exports.LegacyPortalEventGoodsInventoryStatus || (exports.LegacyPortalEventGoodsInventoryStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalEventGoodsInventoryStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalEventGoodsInventoryStatus, "spwn.event.v1.LegacyPortalEventGoodsInventoryStatus", [
    { no: 0, name: "LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_IN_STOCK" },
    { no: 2, name: "LEGACY_PORTAL_EVENT_GOODS_INVENTORY_STATUS_OUT_OF_STOCK" },
]);
/**
 * イベントグッズ情報
 *
 * @generated from message spwn.event.v1.LegacyPortalEventGoods
 */
class LegacyPortalEventGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 紐づくイベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントグッズID
         *
         * @generated from field: string event_goods_id = 2;
         */
        this.eventGoodsId = "";
        /**
         * Firestoreのgoodsのevent_id
         *
         * @generated from field: string event_firestore_id = 3;
         */
        this.eventFirestoreId = "";
        /**
         * Firestoreのgoodsのevent_goods_id
         *
         * @generated from field: string event_goods_firestore_id = 4;
         */
        this.eventGoodsFirestoreId = "";
        /**
         * クラス(商品)番号
         *
         * @generated from field: int32 class = 5;
         */
        this.class = 0;
        /**
         * クラス(商品)名
         *
         * @generated from field: string class_name = 6;
         */
        this.className = "";
        /**
         * サブクラス(バリエーション)番号
         *
         * @generated from field: int32 sub_class = 7;
         */
        this.subClass = 0;
        /**
         * サブクラス(バリエーション)名
         *
         * @generated from field: string sub_class_name = 8;
         */
        this.subClassName = "";
        /**
         * バリエーションがあるかどうか
         *
         * @generated from field: bool has_variants = 9;
         */
        this.hasVariants = false;
        /**
         * 商品名
         *
         * @generated from field: string name = 10;
         */
        this.name = "";
        /**
         * 商品説明
         *
         * @generated from field: string description = 11;
         */
        this.description = "";
        /**
         * 表示優先度
         *
         * @generated from field: int32 priority = 12;
         */
        this.priority = 0;
        /**
         * クラスサムネイルURL一覧
         *
         * @generated from field: repeated string class_thumbnails = 14;
         */
        this.classThumbnails = [];
        /**
         * 価格
         *
         * @generated from field: int32 price = 16;
         */
        this.price = 0;
        /**
         * ハッシュタグ
         *
         * @generated from field: repeated string hashtags = 19;
         */
        this.hashtags = [];
        /**
         * ウォッチリストに含まれるか
         *
         * @generated from field: bool is_in_watchlist = 20;
         */
        this.isInWatchlist = false;
        /**
         * 販売ステータス
         *
         * @generated from field: spwn.event.v1.LegacyPortalEventGoodsSalesStatus sales_status = 21;
         */
        this.salesStatus = LegacyPortalEventGoodsSalesStatus.UNSPECIFIED;
        /**
         * 在庫ステータス
         *
         * @generated from field: spwn.event.v1.LegacyPortalEventGoodsInventoryStatus inventory_status = 22;
         */
        this.inventoryStatus = LegacyPortalEventGoodsInventoryStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalEventGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalEventGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalEventGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalEventGoods, a, b);
    }
}
exports.LegacyPortalEventGoods = LegacyPortalEventGoods;
LegacyPortalEventGoods.runtime = protobuf_1.proto3;
LegacyPortalEventGoods.typeName = "spwn.event.v1.LegacyPortalEventGoods";
LegacyPortalEventGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_goods_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "class", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sub_class", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "sub_class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "has_variants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "class_thumbnails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "specification", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "release_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 18, name: "close_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 19, name: "hashtags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 20, name: "is_in_watchlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "sales_status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalEventGoodsSalesStatus) },
    { no: 22, name: "inventory_status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalEventGoodsInventoryStatus) },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map